import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { OrderDetailsDialog } from "../components/OrderDetailsDialog";
import { OrderHistoryView } from "../components/OrderHistoryView";
import type { Order } from "@/types";

export function OrdersPage() {
  const [selectedOrder, setSelectedOrder] = useState<Order | null>(null);
  const [searchParams, setSearchParams] = useSearchParams();

  const shiftId = searchParams.get("shiftId");

  const clearShiftFilter = () => {
    const next = new URLSearchParams();
    setSearchParams(next);
  };

  return (
    <div className="min-h-screen bg-muted/30">
      <div className="border-b bg-background">
        <div className="container mx-auto px-4 py-4 md:px-6">
          <h1 className="text-2xl font-bold">Orders</h1>
          <p className="text-sm text-muted-foreground">
            Browse completed orders, take refunds, and reprint receipts.
          </p>
        </div>
      </div>
      <div className="container mx-auto px-4 py-4 md:px-6">
        <OrderHistoryView
          shiftId={shiftId ?? undefined}
          onClearShiftFilter={clearShiftFilter}
          setSelectedOrder={setSelectedOrder}
        />
      </div>
      {selectedOrder && (
        <OrderDetailsDialog
          order={selectedOrder}
          onClose={() => setSelectedOrder(null)}
        />
      )}
    </div>
  );
}
